export default __webpack_public_path__ + "static/media/feed-page.5179b6cb.png";